import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { verifyRecoveryCode } from '@/api/auth.api';
import { completeLoginSession } from '@/lib/auth/complete-login-session';

/**
 * Step 2 of login with a one-time recovery code instead of an authenticator
 * code (MYN-241). Same landing as `useVerifyTwoFactor`.
 */
export function useVerifyRecoveryCode(preAuthToken: string, returnTo?: string) {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (code: string) => verifyRecoveryCode({ code, preAuthToken }),
    onSuccess: (result) => completeLoginSession(result, { queryClient, navigate, returnTo }),
  });
}
